import React from 'react';
import { trustItems } from '../../data/site';
import { Container } from '../ui/Container';
export function TrustStrip() {
  return <div className="on-dark bg-ink text-white" data-id="element-198" data-mp="3l5bairsyb2dr">
      <Container data-id="element-199" data-mp="3h4zopbouqw0p">
        <ul className="grid divide-y divide-white/10 sm:grid-cols-3 sm:divide-x sm:divide-y-0" data-id="element-200" data-mp="3h4hmlyfidnkv">
          {trustItems.map(item => <li key={item} className="flex items-center gap-3 py-5 font-display text-xl font-semibold uppercase tracking-wide sm:justify-center sm:py-7 sm:text-[1.4rem]" data-id="element-201" data-mp="3c80xp20hj56q">
              <span className="h-2 w-2 shrink-0 bg-sun" aria-hidden="true" data-id="element-202" data-mp="8rkclwb3c93v" />
              {item}
            </li>)}
        </ul>
      </Container>
    </div>;
}